import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { Scale } from 'lucide-react'
import { PoliciesScreen } from '@/screens/govern/SCR-188-policies'

export const Route = createFileRoute('/_app/govern/policies')({
  staticData: { screen: { id: 'SCR-188', title: 'Policies', group: 'Govern', perm: ['contract.manage', 'deployment.manage'], order: 3, description: 'Rules ESM checks before reading or writing memory, building context or reading traces.', icon: Scale } },
  validateSearch: z.object({
    policy: z.string().max(200).optional().catch(undefined),
    tab: z.enum(['editor', 'test', 'replay', 'schema']).optional().catch(undefined),
  }),
  component: PoliciesScreen,
})
